'use client';

import { FooterSectionsProvider } from '@contexts/footerSectionsContext';
import { FOOTER_PAGE_TYPE } from '@helpers/constants/footerSections';
import { getFooterPageType, resolveFooterSections } from '@helpers/functions/footer-sections';
import { Box } from '@madeiramadeirabr/layout-web';
import { TFooterSectionsContent } from '@services/datocms/common/getFooter';
import { useRouter } from 'next/compat/router';
import dynamic from 'next/dynamic';
import { useMemo } from 'react';

const Sections = dynamic(() => import('@app/common/VisualBlocks/Sections'));

type FooterSectionsProps = {
  sections?: TFooterSectionsContent[];
};

function FooterSections({ sections }: Readonly<FooterSectionsProps>) {
  const router = useRouter();
  const route = router?.route ?? '';
  const pageType = useMemo(() => getFooterPageType(route), [route]);
  const pageSections = useMemo(
    () => resolveFooterSections(sections, pageType),
    [sections, pageType]
  );

  if (!pageSections) {
    return null;
  }

  const isPdpPage = pageType === FOOTER_PAGE_TYPE.PDP;

  return (
    <FooterSectionsProvider>
      <Box
        css={{
          width: '100%',
          pt: '$xlarge',
          pb: isPdpPage ? '120px' : '$xlarge',
          $md: { pb: '$xlarge' },
        }}
      >
        <Sections sections={pageSections} />
      </Box>
    </FooterSectionsProvider>
  );
}

export default FooterSections;
